import connection from '../../../../api/config/connection';
import React from 'react';

export default {
  search: (input, callback, optionsSourceBaseUrl) => {
    let params = {
      text: input
    }

    const querystringStart = optionsSourceBaseUrl.indexOf('?');
    if(querystringStart !== -1) {
      const querystring = optionsSourceBaseUrl.substr(querystringStart + 1);
      params = querystring.split('&').reduce((params, param) => {
        const parts = param.split('=');
        params[parts[0]] = parts[1];
        return params;
      }, params);
    }

    const options = {
      method: 'GET',
      url: `${optionsSourceBaseUrl}`,
      params
    };

    connection
      .instance()(options)
      .then(response => {
        try {
          const options =
            !response.data.result || !response.data.result.results || !response.data.result.results.routes
              ? []
              : response.data.result.results.routes.map(route => {
                  const { route_id, route_long_name, route_short_name, agency_id } = route;
                  return {
                    label: `Lijn ${route_short_name}: ${route_long_name}`,
                    value: {
                      route_id,
                      route_long_name,
                      route_short_name,
                      agency_id
                    }
                  };
                });

          callback(options);
        } catch (ex) {
          console.error(ex);
          callback();
        }
      })
      .catch(response => {
        callback();
      });
  },

  convertSelectValueToValue: (selectValue, callback) => {
    callback(selectValue.value);
  },

  convertValueToSelectValue: value => {
    const selectValue = value
      ? {
          label: `Lijn ${value.route_short_name}: ${value.route_long_name}`,
          value: JSON.stringify(value)
        }
      : null;

    return selectValue;
  },

  components: config => {
    return {
      Option: data => {
        const agencyId = data.value.agency_id;
        const className = `select__option ${data.isFocused || data.isSelected ? 'select__option--is-focused' : ''}`;

        return (
          <div {...data.innerProps} className={className}>
            <div>
              {agencyId ? <div className="select__option-grayed select__option-small">{agencyId} </div> : ''}
              <div className="select__option-bold">{data.label}</div>
            </div>
          </div>
        );
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/SelectSources/Lijnnummer.js